module.exports = __webpack_public_path__ + "img/p1-pic@2x.c9ae1355.jpg";